import { GetTaskDto } from "../features/tasks/types";

/**
 * Sorts an array of tasks by rating and updatedAt, with type checks.
 * @param {Array} tasks - Array of task objects to sort.
 * @returns {Array} - Sorted array of tasks.
 */
export function sortTasks(tasks: GetTaskDto[]) {
  return tasks.sort((a, b) => {
    // Ensure ratings are numbers before comparison
    const ratingA = a.urgency * a.importance;
    const ratingB = b.urgency * b.importance;
    const ratingDifference = ratingB - ratingA;
    return ratingDifference;
  });

  /*
    if (ratingDifference !== 0) {
      return ratingDifference;
    }
    // Safely convert updatedAt to Date objects for comparison
    const dateA = new Date(a.updatedAt);
    const dateB = new Date(b.updatedAt);
    return dateB.getTime() - dateA.getTime(); // More recent updates come first
  });
  */
}
